import { render, staticRenderFns } from "./RelatedCourse.vue?vue&type=template&id=e86617a0&scoped=true&"
import script from "./RelatedCourse.vue?vue&type=script&lang=js&"
export * from "./RelatedCourse.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCourse.vue?vue&type=style&index=0&id=e86617a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86617a0",
  null
  
)

export default component.exports